import React from 'react';

import { useIntl } from 'react-intl';

import AppIcon from '@atlaskit/icon/core/app';
import IconTile from '@atlaskit/icon/icon-tile';

import { useAppearanceForIndex } from '../../../utils/use-random-appearance';

import { messages } from './messages';

export const AppBuildTabIcon = ({ index }: { index: number }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const appearance = useAppearanceForIndex(index, 'ECOSYSTEM_APP');
	return (
		<IconTile
			size="small"
			appearance={appearance}
			label={formatMessage(messages.ecosystemAppIconLabel)}
			icon={() => <AppIcon label={formatMessage(messages.ecosystemAppIconLabel)} />}
		/>
	);
};
